<div class="modal-header">
    <h4>Nueva clase </h4>
    <button type="button" class="close" aria-label="Close" (click)="_close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form>

        <div class="form-group">
            <div class="row pl-4">
                <div class="col-md-12">
                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <!---->
                        <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Clase:</label>
                        <div class="col-md-2">
                            <input style="text-align: center;" class="form-control tsiInput" name="codClase"
                                [(ngModel)]="codClase" type="text"
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"
                                disabled>
                        </div>
                        <div class="col-md-7">
                            <select tabindex="15" class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                name="codClase" [(ngModel)]="codClase" #selectClase
                                (change)="onChangeClases($event.target.value)">
                                <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                                    {{claseSele.codigo+' - '+claseSele.descri}}
                                </option>
                            </select>
                        </div>
                        <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                    </div>
                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <!---->
                        <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                        <div class="col-md-2">
                            <input style="text-align: center;" class="form-control tsiInput" name="codCodigoClase"
                                [(ngModel)]="codCodigoClase" type="text"
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10">
                        </div>
                        <div class="col-md-7">
                            <select tabindex="15" class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                name="codCodigoClase" [(ngModel)]="codCodigoClase" #selectClase>
                                <option *ngFor="let codigoSele of listacodigos" value="{{codigoSele.codigo}}">
                                    {{codigoSele.codigo+' - '+codigoSele.descri}}
                                </option>
                            </select>
                        </div>
                        <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-rounded btn-info m-b-15" tabindex="5" (click)="_ok()"><i
            class="fa fa-save"></i> Guardar</button>
    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="_close()" tabindex="6"><i
            class="fa fa-times-circle"></i> Cancelar</button>
</div>